import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent('div'), {
    key: _ctx.key,
    class: _normalizeClass(["w-full transition-all ease-linear pointer-events-none transform-gpu scale-x-0 origin-left", [
			_ctx.barClasses ? _ctx.barClasses : ' bg-primary-400 shadow-glow'
		]]),
    style: _normalizeStyle([{"height":"2px"}, { '--tw-scale-x': _ctx.progressFactor, 'opacity': _ctx.show ? 1 : 0 }])
  }, null, 8, ["class", "style"]))
}